var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#84C4C9;}\r\n\t.st1{fill:#4D91A6;}\r\n\t.st2{opacity:0.15;fill:#D1EEEA;enable-background:new    ;}\r\n\t.st3{fill:#3F708B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "st0",
    d: "M35,5C18.5,5,5,18.4,5,35c0,16.5,13.4,30,30,30c16.5,0,30-13.4,30-30C65,18.5,51.6,5.1,35,5z  M34.9,60.9C20.6,60.9,9.1,49.3,9.1,35S20.7,9.1,35,9.1S60.8,20.7,60.8,35S49.2,60.9,34.9,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    className: "st1",
    d: "M65,35C65,18.5,51.6,5,35,5c-6.4,0-12.3,2-17.2,5.4l2.1,3.6c4.3-3.1,9.5-4.9,15.1-4.9 c14.3,0,25.9,11.6,25.9,25.9c0,8.6-4.3,16.3-10.8,21l2.1,3.6C59.9,54.2,64.9,45.2,65,35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    className: "st0",
    d: "M38.1,35.3l1.5-2.5l9.7-16.6c-0.4-0.3-0.8-0.6-1.2-0.8c-3.7-2.5-8.2-4-13-4 c-4.8-0.1-9.3,1.4-13,3.8c-0.4,0.3-0.8,0.5-1.2,0.8l9.4,16.6l1.6,2.7l-1.5,2.5L21,53.9c0.3,0.2,0.6,0.4,0.8,0.6c3.7,2.5,8.2,4,13,4 c4.8,0.1,9.3-1.4,13.1-3.8c0.3-0.2,0.6-0.4,0.9-0.6l-9.2-16.2L38.1,35.3z M33.6,27.5l-5.5-9.6c2.2-0.9,4.6-1.4,7.1-1.4 c2.4,0,4.8,0.5,7.1,1.5l-7.2,12.2L33.6,27.5z M41.7,52.1c-2.1,0.8-4.4,1.2-6.8,1.2c-2.3,0-4.6-0.5-6.7-1.3L35,40.4l1.5,2.6 L41.7,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    className: "st2",
    d: "M41.7,52.1c-2.1,0.8-4.4,1.2-6.8,1.2c-2.3,0-4.6-0.5-6.7-1.3L35,40.4l1.5,2.6L41.7,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    className: "st2",
    d: "M42.3,18l-7.2,12.2l-1.6-2.7l-5.5-9.6c2.2-0.9,4.6-1.4,7.1-1.4C37.7,16.6,40.1,17,42.3,18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    className: "st3",
    d: "M35.1,30.2L32,35.3l-1.6-2.8l3.1-5L35.1,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    className: "st3",
    d: "M39.7,38l-3.1,5.2L35,40.4l3.1-5L39.7,38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApm);
export default __webpack_public_path__ + "static/media/logoAPM.0f47b5a7e03e3994006ded1dabf0ef7f.svg";
export { ForwardRef as ReactComponent };